<template>
    <div id="login">
        <el-form :model="data" :rules="rules" ref="login">
            <el-form-item prop="email">
                <el-input v-model="data.email" placeholder="E-Mail" clearable></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input v-model="data.password" placeholder="Password" :show-password="true"></el-input>
            </el-form-item>
            <el-form-item class="submit">
                <el-button type="primary" @click="submit()">Anmelden</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                data: {
                    email: '',
                    password: ''
                },
                rules: {
                    email: [
                        {required: true, message: 'Die E-Mail-Addresse wird benötigt.', trigger: 'blur'},
                        {type: 'email', message: 'Keine gültige E-Mail-Addresse', trigger: ['blur', 'change']}
                    ],
                    password: [
                        {required: true, message: 'Das Passwort wird benötigt.', trigger: ['blur', 'change']}
                    ]
                }
            }
        },
        methods: {
            submit() {
                this.$refs['login'].validate((valid) => {
                    if (valid) {
                        this.$router.push('home')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

    #login {
        @include fullscreen;
        @include center_content;

        > * {
            padding: $padding * 11 $padding * 11 0 $padding * 11;
            border-top: 1px solid $color-secondary;
            border-radius: $padding;
            background-color: white;
        }

        .submit {
            text-align: right;
        }
    }

</style>
